"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveLocationSchema = void 0;
const zod_1 = require("zod");
const lng_lat_1 = require("./lng-lat");
exports.LiveLocationSchema = zod_1.z.object({
    lngLat: lng_lat_1.LngLatSchema,
    timestamp: zod_1.z.number(),
    staleTimestamp: zod_1.z.number(),
});
